/* eslint-disable react/prop-types */
import React from 'react';

/**
 * Content-type mix (026 US3): which meditation/breath types users use, each with a
 * distinct-user count and its share of SESSIONS within its own family. Each family
 * is a scrollable au-panel so a long list scrolls inside its own box instead of
 * stretching the page. Text only; tabular numerals.
 *
 * Props: { data } — { meditation:[{type,distinct_users,sessions,share_pct}], breathing:[...] }
 */
const Family = ({ title, rows, testid }) => (
  <div className="au-panel" data-testid={testid}>
    <div className="au-panel__head">
      <h4 className="au-panel__title">{title}</h4>
    </div>
    {rows && rows.length ? (
      <div className="pause-mix__scroll">
        <ul className="pause-rows">
          {rows.map((r) => (
            <li key={r.type}>
              <span className="pause-rows__label">{r.type || '(untitled)'}</span>
              <span className="pause-rows__val">
                {Number(r.distinct_users).toLocaleString()} users · {Number(r.sessions).toLocaleString()} sessions ({r.share_pct}%)
              </span>
            </li>
          ))}
        </ul>
      </div>
    ) : (
      <div className="au-chart-empty">No content used in this range.</div>
    )}
  </div>
);

const PauseContentMix = ({ data = { meditation: [], breathing: [] } }) => (
  <div data-testid="pause-content-mix">
    <h3 className="au-seg-title">Content-type mix — which content wins</h3>
    <div className="pause-mix-grid">
      <Family title="Meditation types" rows={data.meditation} testid="pause-mix-meditation" />
      <Family title="Breathing types" rows={data.breathing} testid="pause-mix-breathing" />
    </div>
  </div>
);

export default PauseContentMix;
